import styled from 'styled-components';
import { getTheme, size } from 'mol-ui';

export const Container = styled.div`
    height: 100%;
    position: relative;
`;

export const DownloadBox = styled.div`
    align-items: center;
    color: ${ ({ theme: { primaryColor } }) => primaryColor };
    cursor: pointer;
    font-size: 12px;
    display: flex;
    padding: 0px 10px;
    text-decoration: none;
    .download-button {
        color: ${ ({ theme: { primaryColor } }) => primaryColor };
        display: inline-block;
        font-size: 12px;
        text-decoration: none;
    }
`;

export const FilterBox = styled.div`
    align-items: center;
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    display: flex;
    height: 40px;
    padding: 15px 15px 10px 15px;
    z-index: 9;
    ${ size.md(`
        width: 100%;
    `) }
`;

export const FooterContainer = styled.div`
    border-top: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    bottom: 0px;
    height: 30px;
    position: absolute;
    width: 100%;
`;

export const Input = styled.input`
    background: transparent;
    box-shadow: none;
    border: none;
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: .9rem;
    margin-left: 1rem;
    outline: none;
    &::placeholder {
        color: ${ ({ theme: { labelColor } }) => labelColor };
        font-weight: 500;
    }
`;

export const List = styled.div`
    height: calc(100% - ${ ({ footer, searchBar }) => (10 + (searchBar ? 40 : 0) + (footer ? 30 : 0)) }px);
    position: relative;
    overflow-y: auto;
    top: 10px;
`;

export const Search = styled.div`
    align-items: center;
    display: flex;
    flex-grow: 1;
`;
